function initBaseLesson() {
  const dragElement = document.querySelector( '.base-lesson-dragger' );
  const elementThatGetsDraggedRight = document.querySelector( '.base-lesson-recognizes' );
  const originalElementPositionX = elementThatGetsDraggedRight?.getBoundingClientRect().x;
  const desktopView = window.outerWidth > 820;
  const windowWidth = window.innerWidth;
  const minDragPosition = desktopView ? windowWidth * 0.1 : 0;
  const maxDragPosition = desktopView ? windowWidth * 0.9 : windowWidth;
  const halfThePage = windowWidth / 2;

  let dragging = false;
  let touchLastEvent = null;

  if (dragElement) {

    maybeOpenRight( minDragPosition, originalElementPositionX, elementThatGetsDraggedRight );

    if (desktopView) {
      // Tell the browser that we *can* move the element.
      dragElement.addEventListener( 'mousedown', (event) => {
        event.preventDefault();
        dragging = true;
      } );

      // Stop moving the element when mouse button is released.
      document.addEventListener( 'mouseup', (event) => {
        event.preventDefault();

        if (!dragging) {
          return false;
        }

        dragging = false;

        let transformSnapToPosition;

        if (event.pageX > halfThePage) {
          transformSnapToPosition = maxDragPosition - originalElementPositionX;
        } else {
          transformSnapToPosition = minDragPosition - originalElementPositionX;
        }

        elementThatGetsDraggedRight.style.transform = 'translateX(' + transformSnapToPosition + 'px)';
        dragElement.style.transform = 'translateX(' + transformSnapToPosition + 'px)';
        closeAllAccordions();
      } );

      // Move the elements when mouse moves.
      document.addEventListener( 'mousemove', (event) => {
        event.preventDefault();

        if (!dragging) {
          return false;
        }

        let currentDragPositionOnPage = Math.max( minDragPosition, event.pageX );

        if (currentDragPositionOnPage > maxDragPosition) {
          currentDragPositionOnPage = Math.min( currentDragPositionOnPage, maxDragPosition );
        }

        elementThatGetsDraggedRight.style.transform = 'translateX(' + (currentDragPositionOnPage - originalElementPositionX) + 'px)';
        dragElement.style.transform = 'translateX(' + (currentDragPositionOnPage - originalElementPositionX) + 'px)';
      } );
    } else {
      dragElement.addEventListener( 'touchstart', (event) => {
        event.preventDefault();
        dragging = true;
      } );

      dragElement.addEventListener( 'touchend', (event) => {
        event.preventDefault();
        let direction = 'left';

        if (!dragging) {
          return false;
        }

        dragging = false;

        let transformSnapToPosition;

        if (touchLastEvent.touches[0].pageX > halfThePage) {
          transformSnapToPosition = maxDragPosition - originalElementPositionX;
          direction = 'right';
        } else {
          transformSnapToPosition = minDragPosition - originalElementPositionX;
        }

        elementThatGetsDraggedRight.style.transform = 'translateX(' + transformSnapToPosition + 'px)';
        dragElement.style.transform = 'translateX(' + transformSnapToPosition + 'px)';

        if (direction === 'left') {
          dragElement.classList.add( 'dragged-left' );
        } else {
          dragElement.classList.remove( 'dragged-left' );
        }

        closeAllAccordions();
      } );

      dragElement.addEventListener( 'touchmove', (event) => {
        event.preventDefault();

        if (!dragging) {
          return false;
        }

        let currentDragPositionOnPage = Math.max( minDragPosition, event.touches[0].pageX );

        if (currentDragPositionOnPage > maxDragPosition) {
          currentDragPositionOnPage = Math.min( currentDragPositionOnPage, maxDragPosition );
        }

        elementThatGetsDraggedRight.style.transform = 'translateX(' + (currentDragPositionOnPage - originalElementPositionX) + 'px)';
        dragElement.style.transform = 'translateX(' + (currentDragPositionOnPage - originalElementPositionX) + 'px)';

        touchLastEvent = event;
      } );
    }
  }
}

function closeAllAccordions() {
  const allAccordions = document.querySelectorAll( '.base-lesson-accordion' );

  if (!allAccordions) {
    return;
  }

  [...allAccordions].forEach( accordion => {
    accordion.classList.remove( 'open' );
    accordion.querySelector( '.base-lesson-accordion__content-wrapper' ).style.maxHeight = 0;
  } );
}

function maybeOpenRight() {
  const dragElement = document.querySelector( '.base-lesson-dragger' );
  const elementThatGetsDraggedRight = document.querySelector( '.base-lesson-recognizes' );
  const originalElementPositionX = elementThatGetsDraggedRight?.getBoundingClientRect().x;
  const windowWidth = window.innerWidth;
  const desktopView = window.outerWidth > 820;
  const minDragPosition = desktopView ? windowWidth * 0.1 : 0;

  const altParam = new URLSearchParams( window.location.search ).get( 'alt' );
  let transformSnapToPosition = minDragPosition - originalElementPositionX;

  if (altParam && parseInt( altParam ) === 1) {
    if (!desktopView) {
      dragElement.classList.add( 'dragged-left' );
    }

    setTimeout( () => {
      elementThatGetsDraggedRight.style.transform = 'translateX(' + transformSnapToPosition + 'px)';
      dragElement.style.transform = 'translateX(' + transformSnapToPosition + 'px)';
    }, 500 );
    closeAllAccordions();
  }
}

function initBaseLessonIntroZoom() {
  const baseLessonIntro = document.querySelector( '.base-lesson-intro' );

  if (!baseLessonIntro) {
    return;
  }

  document.addEventListener( 'scroll', () => {
    window.requestAnimationFrame( () => {
      const scrollPosition = window.scrollY;
      const percentageInView = ((scrollPosition - baseLessonIntro.offsetTop) / baseLessonIntro.offsetHeight) * 100;
      let scale = .9;

      if (scrollPosition > baseLessonIntro.offsetTop) {
        scale = Math.max( 0.9, (percentageInView / 100) );
      }

      baseLessonIntro.style.scale = Math.min( 1, scale );
    } );
  } );
}

function initHeaderButton(interval) {
  const button = document.querySelector( '.btn--base-lesson' );

  if (!button) {
    return;
  }

  setInterval( () => {
    button.classList.toggle( 'show-right' );
  }, interval );
}

export default {
  init() {
    initBaseLesson();

    if (window.outerWidth > 1200) {
      initBaseLessonIntroZoom();
      initHeaderButton( 20000 );
    }
  },
};